import { ReactComponent as PlanFactIcon } from './plan_fact.svg';

export default PlanFactIcon;
